// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconPresentationAnalytics, IconSettings, IconDevices, IconCpu, IconMap, IconLayoutBoard, IconDesk, IconLock, IconUser } from '@tabler/icons-react';
import { NavItemType } from 'types';

// ==============================|| WIDGET MENU ITEMS ||============================== //

const configuration: NavItemType = {
    id: 'configuration',
    title: <FormattedMessage id="configuration" />,
    icon: IconSettings,
    type: 'group',
    children: [
        {
            id: 'account',
            title: <FormattedMessage id="account" />,
            type: 'item',
            url: '/config/account',
            icon: IconUser,
            breadcrumbs: false
        }
    ]
};

export default configuration;
